(function() {
    'use strict';

    angular
        .module('sideApp')
        .controller('ReporteEvaluativoCUController', ReporteEvaluativoCUController);

    ReporteEvaluativoCUController.$inject = ['$scope', '$state', '$stateParams', 'ReporteEvaluativoCUService','ReporteEvaluativoCURegenerarService', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'LoginService','entity'
    	];

    function ReporteEvaluativoCUController ($scope, $state, $stateParams, ReporteEvaluativoCUService, ReporteEvaluativoCURegenerarService, ParseLinks, AlertService, pagingParams, paginationConstants,LoginService,entity
    		) {
        var vm = this;
        vm.reporte=entity.reporte;
        vm.wrapper=entity;
        vm.tipo=entity.tipo;
        vm.round=round;
        vm.save=save;
        vm.print=print;
        vm.nivelObtenido=nivelObtenido;
        
        function round(valor){
        	return Math.round(valor);
        }
        
        function nivelObtenido(media){
        	var mediaObtenida = parseFloat(media);
        	var limiteInferiorSobresaliente = 3.60;
        	var limiteSuperiorSatisfactorio = 3.59;
        	var limiteInferiorSatisfactorio = 2.81;
        	var limiteSuperiorInsatisfactorio = 2.80;
        	var nivel = 'No aplica';
        	
        	if(mediaObtenida>=limiteInferiorSobresaliente){
        		nivel = 'Sobresaliente';
        	}else{
        		if(mediaObtenida>=limiteInferiorSatisfactorio && mediaObtenida<=limiteSuperiorSatisfactorio ){
        			nivel = 'Satisfactorio';
        		}else{
        			if(mediaObtenida<=limiteSuperiorInsatisfactorio){
        				nivel = 'Insatisfactorio';
        			}
        		}
        	}
        	return nivel;
        }
        
        function print(){
        	window.print();
        }
        
        function save(){
        	 vm.isSaving = true;
        	 if(vm.wrapper.regenerar){
        		 ReporteEvaluativoCURegenerarService.update(vm.wrapper, onSaveSuccess, onSaveError).
               	 $promise.then(function(result){
            		 vm.wrapper.reporte=result;
            	 });
        	 }else{
        		 if (vm.wrapper.reporte.id !== null) {
                	 ReporteEvaluativoCUService.update(vm.wrapper, onSaveSuccess, onSaveError).
                   	 $promise.then(function(result){
                		 vm.wrapper.reporte=result;
                	 });
                 } else {
                	 ReporteEvaluativoCUService.save(vm.wrapper, onSaveSuccess, onSaveError).
                	 $promise.then(function(result){
                		 vm.wrapper.reporte=result;
                	 });
                 }
        	 }
        }
        function onSaveSuccess (result) {
			$scope.$emit('sideApp:reporte', result);
			vm.isSaving = false;
			if (vm.wrapper.tipoUser == 1) {
				$state.go('generarReporteCU', 
				{
					idA: $stateParams.idA,
					idP: $stateParams.idP,
					idAnio: $stateParams.idAnio,
					idIndice: $stateParams.idIndice,
					ic: $stateParams.ic,
					iic: $stateParams.iic,
					tipoEvaluacion: $stateParams.tipoEvaluacion,
					idDependencia: $stateParams.idDependencia,
					nivell: $stateParams.nivell,
					modeloo: $stateParams.modeloo
				}, 
				{ reload: true });
			} else {
				if (vm.wrapper.tipoUser == 2) {
					$state.go('revisionReporteCU', null, { reload: true });
				}
			}
		}

        function onSaveError () {
            vm.isSaving = false;
        }
        
        Highcharts.setOptions({
            chart: {
                backgroundColor: {
                    linearGradient: [0, 0, 500, 500],
                    stops: [
                        [0, 'rgb(255, 255, 255)'],
                        [1, 'rgb(255, 255, 255)']
                        ]
                },
                borderWidth: 2,
                plotBackgroundColor: 'rgba(255, 255, 255, .9)',
                plotShadow: true,
                plotBorderWidth: 1
            }
        });
        
        var chart1 = new Highcharts.Chart({
            chart: {
                renderTo: 'desempeniocategoria',
    			type: 'bar'
            },
            title: {
                text: ''
            },
            xAxis: {
            	categories: [
            		'I. Cumplimiento', 
            		'II. Planeación', 
            		'III. Estrategias didácticas', 
            		'IV. Actitud del profesor', 
            		'V. Comunicación',
            		'VI. Evaluación de los aprendizajes',
            		'VII. Específicas del área de conocimiento'],
//                type: 'integer'
            },
            yAxis: {
                title: {
                    text: null,
                },
                opposite:true,
//                labels: {
//                	enabled: false
//                }
            },
            plotOptions: {
                bar: {
                    dataLabels: {
                        enabled: true
                    }
                }
            },
            legend: {
            	enabled:false
            },
            series: [{
                name: 'Estudiantes',
                data: [
                	parseFloat(vm.wrapper.promedioCumplimiento),
                	parseFloat(vm.wrapper.promedioPlaneacion),
                	parseFloat(vm.wrapper.promedioEstrategiasDidacticas),
                	parseFloat(vm.wrapper.promedioActitudDelProfesor),
                	parseFloat(vm.wrapper.promedioComunicacion),
                	parseFloat(vm.wrapper.promedioEvaluacionAprendizajes),
                	parseFloat(vm.wrapper.promedioEspecificasAreaConocimiento)
                	],
               	color: '#002e5f'
            }]
        });
    }
})();
